import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import accountsReducer from './accounts/accountsSlice';
import transactionsReducer from './transactions/transactionsSlice';
import budgetsReducer from './budgets/budgetsSlice';
import goalsReducer from './goals/goalsSlice';
import categoriesReducer from './categories/categoriesSlice';
import dataPortabilityReducer from './dataPortability/dataPortabilitySlice';
import analyticsReducer from './analytics/analyticsSlice';
import subscriptionsReducer from './subscriptions/subscriptionsSlice';
import transactionRulesReducer from './transactionRules/transactionRulesSlice';
import notificationsReducer from './notifications/notificationsSlice';
import currencyReducer from './currency/currencySlice';
import extensionsReducer from './extensions/extensionsSlice';
import billsReducer from './bills/billsSlice';
import dashboardsReducer from './dashboards/dashboardsSlice';
import { dashboardsApi } from './dashboards/dashboardsApi';
import timezoneReducer from './timezone/timezoneSlice';
import receiptsReducer from './receipts/receiptsSlice';
import templatesReducer from './templates/templatesSlice';
import reviewReducer from './review/reviewSlice';
import displaySettingsReducer from './displaySettings/displaySettingsSlice';
import dashboardEditReducer from '@/store/slices/dashboardEditSlice';
import layoutPresetsReducer from '@/store/slices/layoutPresetsSlice';
import compatibilityReducer from '@/store/slices/compatibilitySlice';
import { dashboardLayoutPresetsApi } from '@/services/dashboardLayoutPresetsApi';
import { dashboardWidgetApi } from '@/services/dashboardWidgetApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    accounts: accountsReducer,
    transactions: transactionsReducer,
    budgets: budgetsReducer,
    goals: goalsReducer,
    categories: categoriesReducer,
    dataPortability: dataPortabilityReducer,
    analytics: analyticsReducer,
    subscriptions: subscriptionsReducer,
    transactionRules: transactionRulesReducer,
    notifications: notificationsReducer,
    currency: currencyReducer,
    extensions: extensionsReducer,
    bills: billsReducer,
    dashboards: dashboardsReducer,
    [dashboardsApi.reducerPath]: dashboardsApi.reducer,
    timezone: timezoneReducer,
    receipts: receiptsReducer,
    templates: templatesReducer,
    review: reviewReducer,
    displaySettings: displaySettingsReducer,
    dashboardEdit: dashboardEditReducer,
    layoutPresets: layoutPresetsReducer,
    compatibility: compatibilityReducer,
    [dashboardLayoutPresetsApi.reducerPath]: dashboardLayoutPresetsApi.reducer,
    [dashboardWidgetApi.reducerPath]: dashboardWidgetApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(
      dashboardsApi.middleware,
      dashboardLayoutPresetsApi.middleware,
      dashboardWidgetApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
